module.exports = __webpack_public_path__ + "img/neonevm.1d351abc.svg";